import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import {
    ADVANIA_VERSIONING_CONFIG,
    AdvaniaVersioningConfigInput,
    defaultAdvaniaVersioningConfig,
} from './advania-versioning.config';
import { VersionService } from './advania-versioning.service';

export { ADVANIA_VERSIONING_CONFIG } from './advania-versioning.config';
export type { AdvaniaVersioningConfig, AdvaniaVersioningConfigInput } from './advania-versioning.config';

export function provideAdvaniaVersioning(config?: AdvaniaVersioningConfigInput): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: ADVANIA_VERSIONING_CONFIG,
            useFactory: () => ({
                ...defaultAdvaniaVersioningConfig,
                ...((typeof config === 'function' ? config() : config) ?? {}),
            }),
        },
        provideAppInitializer(() => {
            inject(VersionService);
        }),
    ]);
}
